<section
  [class.page-wrapper]="!isClientPortal"
  [class.scroll-container]="!isClientPortal"
  *ngIf="article">
  <h1 class="page-title">
    {{ article.Title }}
  </h1>
  <div [innerHtml]="articleHtml"></div>
</section>
